import React from 'react'
import i18n from 'i18next';
import MultiRangeSlider from "./multiRangeSlider/MultiRangeSlider";
import {PopupForm} from "./MailRequest";
import { FiDatabase, FiSearch, FiExternalLink } from "react-icons/fi";
import { LuMicroscope } from "react-icons/lu";
import InfoTooltip from "./InfoTooltip";
import './FilterPanel.css';



class AssayInput extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            type_input: '',
            type: [],
            type_checked: [],
            collection_input: '',
            collection: [],
            collection_checked: [],
            organization_input: '',
            organization: [],
            organization_checked: [],
            sex_input: '',
            sex: [],
            sex_checked: [],
            age: [0, 120],
            age_min: 0,
            age_max: 120,
            age_settings_input: '',
            age_settings: [],
            age_settings_checked: [],
            changing_prop_names: ['sex', 'collection', 'organization', 'type', 'age_settings'],
            changing_prop_names_unchecked: ['length_objects'],
            changing_prop_checked_names: ['sex_checked', 'collection_checked', 'organization_checked', 'type_checked', 'age_settings_checked'],
            query: {},
            length_objects: 0
        }
    }

    receiver_props = (nextProps, cur_prop_name, cur_prop_checked_name) => {
        let next_prop = this.state[cur_prop_name]
        let next_prop_checked = this.state[cur_prop_checked_name]
        if (typeof nextProps[cur_prop_name] !== 'undefined' && typeof nextProps[cur_prop_checked_name] !== 'undefined') {
            let flag = true;
            if (nextProps[cur_prop_name].length === this.state[cur_prop_name].length) {
                flag = false;
                for (const i in nextProps[cur_prop_name]) {
                    if (nextProps[cur_prop_name][i] !== this.state[cur_prop_name][i]) {
                        flag = true
                        break;
                    }
                }
            }
            if (flag) {
                next_prop = nextProps[cur_prop_name]
                next_prop_checked = nextProps[cur_prop_checked_name]
            }
        }
        return [next_prop, next_prop_checked]
    }

    receiver_props_unchecked = (nextProps, cur_prop_name) => {
        let next_prop = this.state[cur_prop_name]
        if (typeof nextProps[cur_prop_name] !== 'undefined') {
            next_prop = nextProps[cur_prop_name]
        }
        return next_prop;
    }

    componentDidUpdate(prevProps) {
        const updates = {};

        for (const i in this.state.changing_prop_names) {
            const propName = this.state.changing_prop_names[i];
            const checkedName = this.state.changing_prop_checked_names[i];

            if (prevProps[propName] !== this.props[propName] ||
                prevProps[checkedName] !== this.props[checkedName]) {
                const next_props = this.receiver_props(this.props, propName, checkedName);
                updates[propName] = next_props[0];
                updates[checkedName] = next_props[1];
            }
        }

        for (const i in this.state.changing_prop_names_unchecked) {
            const propName = this.state.changing_prop_names_unchecked[i];
            if (prevProps[propName] !== this.props[propName]) {
                updates[propName] = this.receiver_props_unchecked(this.props, propName);
            }
        }

        if (Object.keys(updates).length > 0) {
            this.setState(updates);
        }
    }

    handleInput = (event) => {
        event.persist()
        this.setState({
            ...this.state,
            [event.target.name]: event.target.value
        });
    }

    notifyFilterChange = () => {
        if (this.props.onFilterChange) {
            this.props.onFilterChange(this.state);
        }
    }

    handleCheck = (event) => {
        event.persist();
        let check_box_name = `${[event.target.name]}_checked`;
        let id = event.target.dataset.index || event.target.id;
        const checked = [...this.state[check_box_name]];
        checked[id] = !checked[id];
        this.setState({
            [check_box_name]: checked,
        }, this.notifyFilterChange);
    }

    handleCheckAllButton = (event) => {
        event.persist();
        let check_box_name = `${[event.target.name]}_checked`;
        const checked = [...this.state[check_box_name]];
        if (checked.length > 0) {
            let flag = false
            if (checked.reduce((sum, next) => sum + next) === 0) {
                flag = true
            }
            for (const id in checked) {
                checked[id] = flag
            }
            this.setState({
                [check_box_name]: checked,
            }, this.notifyFilterChange);
        }
    }

    isAllSelected = (checkedArray) => {
        return checkedArray.length > 0 && checkedArray.every(c => c);
    }

    handleShowResearchButton = () => {
        // Collect selected filters to pass to biobanks page
        const selectedCollections = [];
        const selectedTypes = [];

        for (const i in this.state.collection_checked) {
            if (this.state.collection_checked[i]) {
                selectedCollections.push(this.state.collection[i]);
            }
        }
        for (const i in this.state.type_checked) {
            if (this.state.type_checked[i]) {
                selectedTypes.push(this.state.type[i]);
            }
        }

        // Build URL with query params
        const params = new URLSearchParams();
        if (selectedCollections.length > 0) {
            params.set('collection', selectedCollections.join(','));
        }
        if (selectedTypes.length > 0) {
            params.set('type', selectedTypes.join(','));
        }

        const queryString = params.toString();
        window.location.href = '/biobanks' + (queryString ? '?' + queryString : '');
    }

    handleChangeMinAge = (val) => {
        const age = [...this.state.age];
        age[0] = val;
        this.setState({
            age: age
        }, this.notifyFilterChange);
    };
    handleChangeMaxAge = (val) => {
        const age = [...this.state.age];
        age[1] = val;
        this.setState({
            age: age
        }, this.notifyFilterChange);
    };

    handleNewRequest = (event) => {
        event.preventDefault();
        let prop_inputs = [];
        let state_prop_names = [];
        for (const i in this.state.changing_prop_names) {
            const prop_name = this.state.changing_prop_names[i]
            const prop_checked_name = this.state.changing_prop_checked_names[i]

            let prop_input = '';
            const prop_fields = this.state[prop_name];
            const prop_checks = this.state[prop_checked_name];

            for (const i in prop_checks) {
                if (prop_checks[i]) {
                    prop_input += prop_fields[i] + ",";
                }
            }
            prop_input = prop_input.slice(0, -1);
            const state_prop_name = `${prop_name}_input`
            prop_inputs.push(prop_input);
            state_prop_names.push(state_prop_name);
        }
        this.setState({
            ...this.state,
            [state_prop_names[0]]: prop_inputs[0],
            [state_prop_names[1]]: prop_inputs[1],
            [state_prop_names[2]]: prop_inputs[2],
            [state_prop_names[3]]: prop_inputs[3],
            [state_prop_names[4]]: prop_inputs[4]
        });
        this.props.createNewRequest({
            ...this.state,
            [state_prop_names[0]]: prop_inputs[0],
            [state_prop_names[1]]: prop_inputs[1],
            [state_prop_names[2]]: prop_inputs[2],
            [state_prop_names[3]]: prop_inputs[3],
            [state_prop_names[4]]: prop_inputs[4]
        });
    }

    renderFilterSection = (name, labelKey, tooltipKey, items, checkedArray, availableSet = null) => {
        const allSelected = this.isAllSelected(checkedArray);

        return (
            <div className="filter-section">
                <div className="filter-header">
                    <span>{i18n.t(labelKey)}</span>
                    <InfoTooltip text={i18n.t(tooltipKey)} />
                    <button
                        type="button"
                        className="filter-select-all-btn"
                        name={name}
                        onClick={this.handleCheckAllButton}
                    >
                        {allSelected ? i18n.t('clear_all_button') : i18n.t('select_all_button')}
                    </button>
                </div>
                <div className="filter-options">
                    {items.map((item, idx) => {
                        const id = `${name}_${item}`;
                        const isAvailable = !availableSet || availableSet.has(item);
                        return (
                            <label
                                key={id}
                                className={`filter-checkbox-label ${!isAvailable ? 'filter-checkbox-disabled' : ''}`}
                            >
                                <input
                                    type="checkbox"
                                    id={id}
                                    data-index={idx}
                                    name={name}
                                    value={item}
                                    checked={checkedArray[idx] || false}
                                    onChange={this.handleCheck}
                                />
                                <span>{i18n.t(id)}</span>
                            </label>
                        );
                    })}
                </div>
            </div>
        );
    }

    render() {
        let {
            query,
            organization,
            organization_checked,
            collection,
            collection_checked,
            type,
            type_checked,
            sex,
            sex_checked,
            age_settings,
            age_settings_checked,
            length_objects
        } = this.state

        let query_organization = []
        for (const checked in organization_checked) {
            if (organization_checked[checked]) {
                query_organization.push(organization[checked])
            }
        }
        let query_collection = []
        for (const checked in collection_checked) {
            if (collection_checked[checked]) {
                query_collection.push(collection[checked])
            }
        }
        let query_type = []
        for (const checked in type_checked) {
            if (type_checked[checked]) {
                query_type.push(type[checked])
            }
        }
        let query_sexes = []
        for (const checked in sex_checked) {
            if (sex_checked[checked]) {
                query_sexes.push(sex[checked])
            }
        }
        let query_age_settings = []
        for (const checked in age_settings) {
            if (age_settings_checked[checked]) {
                query_age_settings.push(age_settings[checked])
            }
        }
        query['organization'] = query_organization
        query['collection'] = query_collection
        query['type'] = query_type
        query['sex'] = query_sexes
        query['age'] = this.state.age
        query['age_settings'] = query_age_settings

        return (
            <form onSubmit={this.handleNewRequest} className="filter-panel">
                <div className="filter-panel-title">
                    <FiDatabase size={20} />
                    <span>{i18n.t("top_filter_assays")}</span>
                </div>

                {this.renderFilterSection(
                    'organization',
                    'filter_organization',
                    'tooltip_filter_organization',
                    this.state.organization,
                    this.state.organization_checked,
                    this.props.availableOrganizations
                )}

                {this.renderFilterSection(
                    'collection',
                    'filter_collection',
                    'tooltip_filter_collection',
                    this.state.collection,
                    this.state.collection_checked,
                    this.props.availableCollections
                )}

                {this.renderFilterSection(
                    'type',
                    'filter_type',
                    'tooltip_filter_type',
                    this.state.type,
                    this.state.type_checked,
                    this.props.availableTypes
                )}

                {this.renderFilterSection(
                    'sex',
                    'filter_sex',
                    'tooltip_filter_sex',
                    this.state.sex,
                    this.state.sex_checked,
                    this.props.availableSex
                )}

                {/* Age Settings */}
                <div className="filter-section">
                    <div className="filter-header">
                        <span>{i18n.t("filter_age")}</span>
                        <InfoTooltip text={i18n.t("tooltip_filter_age")} />
                        <button
                            type="button"
                            className="filter-select-all-btn"
                            name="age_settings"
                            onClick={this.handleCheckAllButton}
                        >
                            {this.isAllSelected(this.state.age_settings_checked)
                                ? i18n.t('clear_all_button')
                                : i18n.t('select_all_button')}
                        </button>
                    </div>
                    <div className="filter-options">
                        {this.state.age_settings.map((item, idx) => {
                            const id = `age_settings_${item}`;
                            return (
                                <label key={id} className="filter-checkbox-label">
                                    <input
                                        type="checkbox"
                                        id={id}
                                        data-index={idx}
                                        name="age_settings"
                                        value={item}
                                        checked={this.state.age_settings_checked[idx] || false}
                                        onChange={this.handleCheck}
                                    />
                                    <span>{i18n.t(id)}</span>
                                </label>
                            );
                        })}
                    </div>
                    <div className="filter-age-slider">
                        <MultiRangeSlider
                            min={this.state.age_min}
                            max={this.state.age_max}
                            onChange={({min, max}) => void(0)}
                            changeMin={this.handleChangeMinAge}
                            changeMax={this.handleChangeMaxAge}
                        />
                    </div>
                </div>

                <button type="submit" className="filter-apply-btn">
                    <FiSearch size={18} />
                    {i18n.t("request_button")}
                </button>

                <button
                    type="button"
                    className="filter-research-btn-full"
                    onClick={this.handleShowResearchButton}
                >
                    <LuMicroscope size={18} />
                    {i18n.t("biobanks_button")}
                    <FiExternalLink size={14} />
                </button>

                <div className="filter-results-count">
                    <FiDatabase size={18} />
                    <span>{i18n.t("found_assays")}:</span>
                    <span className="count-value">{length_objects}</span>
                </div>

                <PopupForm object_type={"assay"} query={this.state.query} className="filter-request-btn" />
            </form>
        )
    }
}

export {AssayInput};
